import React, { type ComponentProps } from "react";

import { FieldReselectionModal } from "pages/app/scenario-analysis/components/FieldReselectionModal";
import { KeyInsightsModal } from "pages/app/scenario-analysis/components/KeyInsightsModal";
import { ProjectEntryDialog } from "pages/app/scenario-analysis/components/ProjectEntryDialog";
import { TransitionLoadingModal } from "pages/app/scenario-analysis/components/TransitionLoadingModal";
import { FieldSoilExplainerDrawer } from "pages/app/scenario-analysis/components/field-soil-explainer-drawer/FieldSoilExplainerDrawer";
import { HowThisWorksDrawer } from "pages/app/scenario-analysis/components/how-this-works-drawer/HowThisWorksDrawer";
import { ProjectSettingsDrawer } from "pages/app/scenario-analysis/components/project-settings-drawer/ProjectSettingsDrawer";
import { SideBySideExplainerDrawer } from "pages/app/scenario-analysis/components/side-by-side-explainer-drawer/SideBySideExplainerDrawer";
import type { ScenarioAnalysisModal, ScenarioAnalysisModalsOpen } from "pages/app/scenario-analysis/hooks/useModalState";

type ScenarioAnalysisModalsProps = {
  openModals: ScenarioAnalysisModalsOpen;
  onCloseModal: (modal: ScenarioAnalysisModal) => void;
  transition: ComponentProps<typeof TransitionLoadingModal>;
  projectEntry: ComponentProps<typeof ProjectEntryDialog>;
  projectSettings: Omit<ComponentProps<typeof ProjectSettingsDrawer>, "visible" | "onClose">;
  keyInsights: Omit<ComponentProps<typeof KeyInsightsModal>, "open" | "onClose">;
  howThisWorks: Omit<ComponentProps<typeof HowThisWorksDrawer>, "visible" | "onClose">;
  fieldReselect: Omit<ComponentProps<typeof FieldReselectionModal>, "open">;
};

/** The analysis page's modals and drawers; which are open comes from useModalState. */
export const ScenarioAnalysisModals = ({
  openModals,
  onCloseModal,
  transition,
  projectEntry,
  projectSettings,
  keyInsights,
  howThisWorks,
  fieldReselect,
}: ScenarioAnalysisModalsProps) => (
  <>
    <TransitionLoadingModal {...transition} />
    <ProjectEntryDialog {...projectEntry} />
    <ProjectSettingsDrawer visible={openModals.projectSettings} onClose={() => onCloseModal("projectSettings")} {...projectSettings} />
    <KeyInsightsModal open={openModals.keyInsights} onClose={() => onCloseModal("keyInsights")} {...keyInsights} />
    <FieldSoilExplainerDrawer visible={openModals.fieldSoilExplainer} onClose={() => onCloseModal("fieldSoilExplainer")} />
    <SideBySideExplainerDrawer visible={openModals.sideBySideExplainer} onClose={() => onCloseModal("sideBySideExplainer")} />
    <HowThisWorksDrawer visible={openModals.howThisWorks} onClose={() => onCloseModal("howThisWorks")} {...howThisWorks} />
    <FieldReselectionModal open={openModals.fieldReselect} {...fieldReselect} />
  </>
);
